import React, { Component } from 'react';

import './Table.css';
import Spinner from '../spinner/Spinner';
import TableRow from './TableRow';
import TableCheckbox from './TableCheckbox';
import SimplePaginationLinks from '../SimplePaginationLinks';

import FormControl from '../FormControl';
class Table extends Component {

  get limits() {
    return [
      {
      label: '25',
      value: '25'
    },
    {
      label: '50',
      value: '50'
    },
    {
      label: '100',
      value: '100'
    },
    {
      label: '250',
      value: '250'
    },
    {
      label: '500',
      value: '500'
    },
    {
      label: '1000',
      value: '1000'
    }];
  }

  handleCheckboxCellClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  }

  handleToggleSelection = (checked) => {
    const { rowKey, rowSelection, data } = this.props;

    if (checked) {
      rowSelection.onChange({
        selectedRowKeys: data.map((item) => item[rowKey]),
        selectedRows: [...data]
      });
    } else {
      rowSelection.onChange({
        selectedRowKeys: [],
        selectedRows: []
      });
    }
  }

  getTableHeading = (item) => {
    const { className = '', align = 'left' } = item;
    const classNames = `text-${align} ${className}`;

    return (
      <th key={ item.key }
        className={ classNames }
      >
        { item.title }
      </th>
    );
  }

  getTableHead = () => {
    const { columns, rowSelection, data = [] } = this.props;
    const partialSelection = !!rowSelection && rowSelection.selectedRowKeys.length > 0
      && data.length > rowSelection.selectedRowKeys.length;
    const fullSelection = !!rowSelection && rowSelection.selectedRowKeys.length > 0
      && data.length === rowSelection.selectedRowKeys.length;

    const base = !rowSelection ? [] : [(
      <th className="fa-table-check-box-cell" key="table-selection">
          <TableCheckbox
            partial={ partialSelection }
            checked={ fullSelection }
            onChange={ this.handleToggleSelection }
          />
      </th>
    )];

    const headings = base.concat(columns.map(this.getTableHeading));

    return (
        <tr>
          { headings }
        </tr>
    )
  }

  handleOnRowSelection = (item, action) => {
    const { rowKey, rowSelection, data } = this.props;

    let selectedRowKeys = [...rowSelection.selectedRowKeys];
    let selectedRows = [];

    if (action === 'select') {
      selectedRowKeys = selectedRowKeys.concat([item[rowKey]]);
    } else {
      selectedRowKeys = rowSelection.selectedRowKeys.filter((selected) => selected !== item[rowKey])
    }

    selectedRows = data.filter((row) => selectedRowKeys.indexOf(row[rowKey]) !== -1);

    rowSelection.onChange({
      selectedRowKeys,
      selectedRows
    });
  }

  getTableRow = (item, index) => {
    const { columns, rowSelection, rowKey, onRowClick, onRow } = this.props;

    const props = !!onRow ? onRow(item) : {};

    return (
      <TableRow
        key={ rowKey ? item[rowKey] : index }
        index={ index }
        columns={ columns}
        data={ item }
        selected={ !!rowSelection ? rowSelection.selectedRowKeys.indexOf(item[rowKey]) !== -1 : false }
        rowSelection={ !!rowSelection }
        onRowClick={ onRowClick }
        onRowSelection={ this.handleOnRowSelection }
        { ...props }
      />
    );
  }

  getTableRows = () => {
    const { data } = this.props;

    const rows = data.map(this.getTableRow);

    return rows;
  }

  getTableFooter = () => {

  }

  handleOnPageLimitChange = (values) => {
    const { pagination, pagination: { onPageLimitChange } } = this.props;

    onPageLimitChange && values.limit !== pagination.metadata.limit && onPageLimitChange(values.limit);
  }

  render() {
    const {
      data,
      loading,
      emptyLegend,
      emptyHint,
      className = 'table-hover table-stripped',
      pagination,
      tableProps = {}
    } = this.props;

    const paginationAlignment = !!pagination ? pagination.align || 'right' : 'right';

    let flexAlignment = '';

    switch (paginationAlignment) {
      case 'left':
          flexAlignment = 'left';
        break;

      case 'right':
          flexAlignment = 'end';
        break;

      default:
          flexAlignment = 'center';
        break;
    }

    return (
      <div className="fa-table-container table-responsive">
        <table className={ `table ${className}`} {...tableProps}>
          <thead>
            { this.getTableHead()  }
          </thead>

          <tbody>
            { this.getTableRows() }
          </tbody>
        </table>

        { !!pagination && !pagination.metadata.count && (!data || data.length === 0) && (
            <div className="text-center text-muted">
              <strong data-testid="TableEmptyResults">
                { emptyLegend || 'No se han encontrado resultados.' }
              </strong>

              { !!emptyHint && (
                <p className="text-muted">{ emptyHint }</p>
              )}
            </div>
        )}

        { (!pagination && (!data || data.length === 0)) && (
            <div className="text-center text-muted">
              <strong>
                { emptyLegend || 'Sin datos para mostrar.' }
              </strong>

              { !!emptyHint && (
                <p className="text-muted">{ emptyHint }</p>
              )}
            </div>
        )}

        { !!pagination && pagination.metadata.current_page >= 1 && pagination.metadata.per_page >= pagination.metadata.count && (
          <div className={ `text-${paginationAlignment}` }>
            <div className="d-inline-block mr-2">
              <FormControl type="select"
                name="limit"
                className="page-limit text-center"
                value={ (!!pagination && pagination.metadata.limit) || '25' }
                options={ this.limits }
                onChange={ this.handleOnPageLimitChange }
              />
            </div>

            <div className="pagination-container">
              <SimplePaginationLinks
                className={ `justify-content-${flexAlignment}` }
                disabled={ loading }
                pagination={ pagination.metadata }
                onPageChange={ pagination.onPageChange }
              />
            </div>
          </div>
        )}

        { !!loading && (
            <div className="loading-spinner" data-testid="TableLoadingSpinner">
              <Spinner className="spinner" />
            </div>
        )}
      </div>
    )
  }
}

export default Table;
